import ScopeConstants from "constants/ScopeConstants"

export const OutstandingTimesheetTeamScope = {
    key: ScopeConstants.OUTSTANDING_TIMESHEET_TEAM,
    selector: (state) => state.outstandingTimesheetsTeam,
    tokenSelector: (state) => state.authentication.token,
    fetchEndpoint: "/api/Timesheet/SearchTeamOutstanding/",
    updateEndpoint: "/api/Timesheet/UpdateTeam/",
}